
<section class="ui_progressbar">
  <div class="progressbar">
    <div class="progressbar_wrap">
      <div class="progressbar_bar" :style="'width:'+ percentage " ></div>
    </div>
    <div class="progressbar_text">{{percentage}}</div>
    <!-- <div class="spin"></div> -->
  </div>
</section>

